<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div :class="b()">
    <SharedAuthCard
      headerSvg="fingerprint"
      headerTitle="Вход в систему"
      footerTitle="У вас еще нет учетной записи?"
    >
      <template #default>
        <LoginForm
          :loading="isLoading"
          :message="message"
          v-model:login="authLoginRequest.login"
          v-model:password="authLoginRequest.password"
          v-model:isRemember="authLoginRequest.remember"
          @login="handleLogin"
          @google="handleGoogle"
        />
      </template>

      <template #footer>
        <UILink
          label="Создать аккаунт"
          view="main-outline"
          to="/registration"
        />
      </template>
    </SharedAuthCard>

    <SharedModal2fa
      :isVisible="show2faModal"
      :requiresMail2fa="requiresMail2fa"
      :requiresGoogle2fa="requiresGoogle2fa"
      :email="authLoginRequest.login"
      :remember="authLoginRequest.remember"
      @close="handle2faClose"
      @confirm="handle2faConfirm"
    />
  </div>
</template>
